import { withQuery } from 'ufo'

export function useConfDataURL(
  currentUrl: MaybeRefOrGetter<URL> = useCurrentURL(),
) {
  const partner = usePartner()
  return computed(() => {
    const url = toValue(currentUrl)
    return new URL(
      withQuery(getUrlFullPath(url), { partnerid: partner.id || undefined }),
      useRequestURL().origin,
    )
  })
}

export function useContentWidth(size: ScreenSize = 'lg') {
  const isRedesign = useFlag('srp-redesign')
  const confData = useConfdata()

  const isContentFullWidth = computed(
    () => confData.pagetype === 'search' && isRedesign.value,
  )

  const contentWidthClass = computed(() =>
    isContentFullWidth.value ? `container-fluid-xl` : `container-fluid-${size}`,
  )

  return { isContentFullWidth, contentWidthClass }
}
